import { css } from "aphrodite";
import styles from "./styles";
import { CustomDatePicker } from "../../../../common/components/CustomDatePicker";
import SlotListPicker from "../../../../common/components/SlotListPicker/SlotListPicker";
import { CustomMainButton } from "../../../../common/components/CustomMainButton";
import { useState } from "react";
import { useNavigate } from "react-router";
import { MobileTitle } from "../../../../common/components/MobileTitle";
import calendarMobileIcon from "../../../../assets/icons/calendarMobileIcon.svg";
import timeMobileIcon from "../../../../assets/icons/timeMobileIcon.svg";
import { useTranslation } from "react-i18next";
import { RequestLayout } from "../../../../common/components/RequestLayout";
import { CommonLayout } from "../../../../common/components/CommonLayout";
import {stepLayoutItemsId} from "../../../../../Utils";
import {Appointment} from "../../../../../Models";
import {RoutePath} from "../../../../../Utils/routePath";
import {useSelector} from "react-redux";

const DateAndTimeMobileView = ({
    error,
    loading,
    slotItems,
    onDateChange,
    selectAvailableSlot,
    onSlotClick,
    handleContinue,
    appointmentDataChanged,
    slotSelectedOnThisPage,
    selectedSlotDataVisibility,
    availableDates = [],
    firstAvailableDateWithSlot = new Date(),
}) => {
    const [selectDate, setSelectDate] = useState(true);
    const navigate = useNavigate();
    const layoutItems = useSelector(Appointment.getStepItems);
    const activeStepId = stepLayoutItemsId.selectDateAndTime;
    const activeStep = layoutItems?.find((item) => item.id === activeStepId);
    const isAppointmentByBranch = useSelector(Appointment.getIsAppointmentByBranch);
    const [t] = useTranslation(["translation"]);

    const handleContinueButtonPressed = () => {
        if (selectDate) {
            setSelectDate(false);
        } else {
            handleContinue();
        }
    };

    const handleGoBackButtonPressed = () => {
        if (selectDate) {
            const activeStepIndex = layoutItems.findIndex(
                (item) => item.id === activeStep?.id
            )
            if (activeStepIndex > 0) {
                const prevStep = layoutItems[activeStepIndex - 1];
                if (isAppointmentByBranch) {
                    if (prevStep.id === stepLayoutItemsId.selectSubService) {
                        Appointment.setSelectedServiceGroupId('');
                    } else if (prevStep.id === stepLayoutItemsId.selectService) {
                        Appointment.setSelectedServiceGroupId('');
                        Appointment.setSelectedSubServiceGroupId('');
                    } else if (prevStep.id === stepLayoutItemsId.selectBranch) {
                        Appointment.setSelectedSubServiceGroupId('');
                        Appointment.setSelectedServiceGroupId('');
                        Appointment.setSelectedBranch(null, null, null);
                    }
                } else {
                    if (prevStep.id === stepLayoutItemsId.selectBranch) {
                        Appointment.setSelectedBranch(null, null, null);
                    } else if (prevStep.id === stepLayoutItemsId.selectSubService) {
                        Appointment.setSelectedServiceGroupId('');
                        Appointment.setSelectedBranch(null, null, null);
                    } else if (prevStep.id === stepLayoutItemsId.selectService) {
                        Appointment.setSelectedSubServiceGroupId('');
                        Appointment.setSelectedServiceGroupId('');
                        Appointment.setSelectedBranch(null, null, null);
                    }
                }
                navigate(prevStep.path, { replace: true });
            } else {
                navigate(RoutePath.appointmentPage);
            }
        } else {
            setSelectDate(true);
        }
    };
    return (
        <CommonLayout>
            <MobileTitle
                onClickBackButton={handleGoBackButtonPressed}
                iconSrc={selectDate ? calendarMobileIcon : timeMobileIcon}
                title={selectDate ? t("Select Date") : t("Select Time")}
            />
            <RequestLayout error={error} loading={loading}>
                <div className={css(styles.container)}>
                    <div className={css(styles.mainDiv)}>
                        {selectDate ? (
                            <CustomDatePicker
                                title=""
                                onDateChange={onDateChange}
                                minDate={firstAvailableDateWithSlot}
                                availableDates={availableDates}
                            />
                        ) : (
                            <SlotListPicker
                                title=""
                                slotItems={slotItems}
                                onSlotClick={onSlotClick}
                                activeSlot={selectAvailableSlot}
                            />
                        )}
                        <CustomMainButton
                            isDisabled={!selectDate && (!selectAvailableSlot || (!slotSelectedOnThisPage && !selectedSlotDataVisibility))}
                            value={t("Continue")}
                            fixedSize={false}
                            textVariant={"body1"}
                            style={styles.customButton}
                            onClick={handleContinueButtonPressed}
                        />
                    </div>
                </div>
            </RequestLayout>
        </CommonLayout>
    );
};

export default DateAndTimeMobileView;
